import { Container, Card, Grid, Typography, Button } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import Countdown from "react-countdown";
import { RootState, RootDispatch } from "../../model";
import { PROD_OPENTIME } from "../../const/config";
import { useRematch } from "../../utils/useRematch";
import human from "../../assets/human.png";

import "./index.less";
import { useState } from "react";

let OPENTIME = PROD_OPENTIME;

const mapState = (state: RootState) => ({
  ...state.main,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.modal,
  ...dispatch.game,
});

const countDownRender = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      size="large"
      className="mint-button"
    >
      OPEN MINT AFTER {hours < 10 ? `0${hours}` : hours}:
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </Button>
    // <div className="grant-data data-count-down">
    //   <span style={{ fontFamily: '"Montserrat", sans-serif' }}>Reset in</span>{" "}
    //   {hours < 10 ? `0${hours}` : hours}:
    //   {minutes < 10 ? `0${minutes}` : minutes}:
    //   {seconds < 10 ? `0${seconds}` : seconds}
    // </div>
  );
};

export default function Banner() {
  const [
    { isMainNet, saleMintedNum, canRewardTimes, loading },
    { openModal, winnerGetReward },
  ] = useRematch(mapState, mapDispatch);

  const [completed, setCompleted] = useState(false);

  return (
    <div className="banner">
      <Container maxWidth="lg">
        <Grid container alignContent="space-between" spacing={4}>
          <Grid item xs={12} md={5}>
            <Grid
              container
              direction="column"
              alignItems="flex-start"
              style={{ height: "100%" }}
            >
              <Typography
                component="div"
                variant="h6"
                className="content"
                style={{ color: "#ffc938" }}
              >
                2021.07.10 OPENING
              </Typography>
              <Typography
                component="div"
                variant="h2"
                className="content"
                style={{ margin: "15px 0px" }}
              >
                IT’S ABOUT <span style={{ color: "#ffc938" }}>KUNGFU</span>{" "}
                Metaverse
              </Typography>
              <Typography
                component="div"
                variant="h6"
                className="desc"
                style={{ marginTop: "5px" }}
              >
                A collaborative NFT project by KungFu lovers around the world.
              </Typography>
              {canRewardTimes > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  className="mint-button"
                  disabled={
                    canRewardTimes <= 0 || loading.effects.game.winnerGetReward
                  }
                  onClick={() => {
                    winnerGetReward();
                  }}
                >
                  GET GAME REWARD
                </Button>
              )}
              <Button
                variant="contained"
                color="secondary"
                size="large"
                className="mint-button"
                disabled={!isMainNet || saleMintedNum === 8800}
                onClick={() => {
                  openModal("mint");
                }}
              >
                {saleMintedNum === 8800 ? "SOLD OUT" : "Mint Now"}
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container alignItems="center" className="role-container">
              <div className="moon">
                <img src={human} className="role-img" alt="" />
                <Card className="role-desc">
                  <CardContent>
                    <div className="role-desc-title">#The Ancient One</div>
                    <div className="trait_type">· Race: God</div>
                    <div className="trait_type">· Weapon: Gourd Staff</div>
                    <div className="trait_type">· Item: Red Fairy Bird</div>
                  </CardContent>
                </Card>
                <Card className="role-rarity">
                  <CardContent>
                    <StarRoundedIcon color="secondary" />
                    <StarRoundedIcon color="secondary" />
                    <StarRoundedIcon color="secondary" />
                    <StarRoundedIcon color="secondary" />
                    <StarRoundedIcon color="disabled" />
                    {/* <StarRoundedIcon color="secondary" /> */}
                    <div className="rarity-text"># Super rare</div>
                  </CardContent>
                </Card>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
